import React from "react";
import './AlertMahuti.css'

export default function AlertMahuti(props) {
    let lpParams = props.landingPageParams;
    
    const alertType = props.role === 'danger' || props.role === 'danger-filled' ? 'alert-danger' :
    props.role === 'success' || props.role === 'success-filled' ? 'alert-success' : ''

    return <div className={"AlertMahuti m-1 almoni_tzar_normal" + alertType} role='alert'>

        <div className="text-center mt-2 mb-0">
            <span className="fb_title highlight_text pe-1">{lpParams.Footer_Banner_Colored_Title_Prefix__c}</span>
            <span className="fb_title">{lpParams.Footer_Banner_Title__c}</span>            
        </div>
        <div className="fb_subtitle text-center mb-1"><span role="list">{lpParams.Footer_Banner_Subtitle__c}</span></div>
    </div>
}